import "./src/custom-style.css";
import "./src/tailwind.css";


import { wrapRootElement as wrap } from "./wrap-root-element";

export const wrapRootElement = wrap
